import React, { useState } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { Container, Form, Button, ButtonToolbar, Jumbotron } from 'react-bootstrap';
import { BASE_URL, HEADER_OPTIONS } from './lib/basic';
import { openNotificationWithIcon } from './lib/utils';

const ResetPassword = () => {
  const { token } = useParams();
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [passwordSent, setPasswordSent] = useState(false);
  const [message, setMessage] = useState('');

  const handleResetPassword = async () => {
    if (password !== confirmPassword) {
      setPassword('');
      setConfirmPassword('');
      setMessage('Password does not match, please re-entry');
      return;
    }

    try {
      const data = { token, password };
      const response = await axios.post(`${BASE_URL}/reset`, data, HEADER_OPTIONS);
      
      openNotificationWithIcon('success', response.data.message);
      setPasswordSent(true);
      setMessage(response.data.message);

      setTimeout(() => {
        window.location.replace('/');
      }, 2000);
    } catch (error) {
      if (error.response) {
        openNotificationWithIcon('error', error.response.data.message);
      } else if (error.request) {
        openNotificationWithIcon('error', 'No internet!');
      } else {
        openNotificationWithIcon('error', error.message);
      }
    }
  };

  return (
    <Container className="loading">
      <style type="text/css">
        {`
          .loading {
            background-color: red;
            min-height: 100vh;
            min-width: 100vw;
            background-image: url('/img/background.jpg');
            background-size: 120vw;
            opacity: 0.6;
          }

          .vertical-center {
            width: 50vh;
            margin: 0 auto;
            background: linear-gradient(rgba(0, 255, 204, 0.5), rgba(0, 204, 102, 1));
          }

          .btn-flat {
            background-color: purple;
            color: white;
            margin: 3vh auto 0;
          }

          .btn-xxl {
            padding: 1rem 1.5rem;
            font-size: 1.5rem;
          }

          .login {
            text-align: center;
            margin-bottom: 1em;
            color: white;
          }

          .login-label {
            font-size: 1.5rem;
            font-weight: bold;
          }
        `}
      </style>

      <hr style={{ marginBottom: '20vh', marginTop: '0' }} />

      {!passwordSent ? (
        <Jumbotron className="vertical-center">
          <h1 className="login">Reset Password</h1>
          <h2 style={{ textAlign: 'center', color: 'red', marginBottom: '1.5em' }}>{message}</h2>
          <Form>
            <Form.Group controlId="formGroupPassword">
              <Form.Label className="login-label">New Password</Form.Label>
              <Form.Control
                type="password"
                placeholder="New Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </Form.Group>

            <Form.Group controlId="formGroupConfirmPassword">
              <Form.Label className="login-label">Confirm Password</Form.Label>
              <Form.Control
                type="password"
                placeholder="Confirm Password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
              />
            </Form.Group>
          </Form>

          <ButtonToolbar>
            <Button variant="flat" size="lg" onClick={handleResetPassword}>
              Reset Password
            </Button>
          </ButtonToolbar>
        </Jumbotron>
      ) : (
        <Jumbotron className="vertical-center">
          <h1 className="login">{message}</h1>
          <ButtonToolbar>
            <Button variant="flat" size="lg" href="/">
              Back to Login
            </Button>
          </ButtonToolbar>
        </Jumbotron>
      )}
    </Container>
  );
};

export default ResetPassword;
